<p-table [value]="paginationResult.entities" [lazy]="true" (onLazyLoad)="loadData($event)"
    [rows]="paginationRequest.pageSize" [totalRecords]="paginationResult.filteredEntities"
    [rowsPerPageOptions]="[10,20,30]" [paginator]="true" [loading]="loading"
    [rowHover]="true" [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
    class="custom-table" styleClass="p-datatable-striped">

    <!-- #region TABLE TITLE DEFINITION -->
    <ng-template pTemplate="caption">
        <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            {{ 'tableManagement.cardConsumption.syncProcessLogs.errors' | translate }}
        </div>
    </ng-template>
    <!-- #endregion TABLE TITLE DEFINITION -->

    <!-- #region TABLE COLUMN DEFINITION -->
    <ng-template pTemplate="header">
        <tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">

            <!-- VEHICLE -->
            <th pSortableColumn="vehicle">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'control-panel.vehicles.licensePlate' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="vehicle"></p-sortIcon>
                    </div>
                </div>
            </th>

            <!-- CARD -->
            <th pSortableColumn="card">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.cardsConsumption.card' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="card"></p-sortIcon>
                    </div>
                </div>
            </th>

            <!-- ERROR MESSAGE -->
            <th pSortableColumn="errorMessage">
                <div class="d-flex align-items-center h-100">
                    <div class="d-flex align-items-center justify-content-center flex-fill h-100">
                        {{ 'tableManagement.cardConsumption.syncProcessLogs.errorMessage' | translate }}
                    </div>
                    <div class="d-flex align-items-center h-100">
                        <p-sortIcon field="errorMessage"></p-sortIcon>
                    </div>
                </div>
            </th>

        </tr>
    </ng-template>
    <!-- #endregion TABLE COLUMN DEFINITION -->

    <!-- #region TABLE BODY -->
    <ng-template pTemplate="body" let-entity>
        <tr class="custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
            <td>{{ entity.vehicle }}</td>
            <td>{{ entity.card }}</td>
            <td>{{ entity.errorMessage }}</td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE BODY -->

    <!-- #region TABLE EMPTY MESSAGE -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="3" class="p-0">
                <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message">
                    {{ 'table.tableEmptyMessage' | translate }}!
                </div>
            </td>
        </tr>
    </ng-template>
    <!-- #endregion TABLE EMPTY MESSAGE -->

</p-table>
